/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The permission of the user.
 */
export type ApiPermission = (typeof ApiPermission)[keyof typeof ApiPermission];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiPermission = {
  "api-token:create": "api-token:create",
  "api-token:list": "api-token:list",
  "api-token:delete": "api-token:delete",
  "api:catalog:download": "api:catalog:download",
  "api:catalog:list": "api:catalog:list",
  "api:message:create": "api:message:create",
  "api:message:read": "api:message:read",
  "api:message:confirm": "api:message:confirm",
  "api:message:list": "api:message:list",
  "api:supplier-customer-list:upload": "api:supplier-customer-list:upload",
  "api:supplier-customer-list:synchronize":
    "api:supplier-customer-list:synchronize",
  "api:supplier-customer-list:read": "api:supplier-customer-list:read",
  "api:supplier-customer-list:delete": "api:supplier-customer-list:delete",
  "audiologist:catalog:list": "audiologist:catalog:list",
  "audiologist:supplier:list": "audiologist:supplier:list",
  "catalog:create": "catalog:create",
  "catalog:read": "catalog:read",
  "catalog:list": "catalog:list",
  "catalog:update": "catalog:update",
  "catalog:delete": "catalog:delete",
  "catalog:download": "catalog:download",
  "customer-list:upload": "customer-list:upload",
  "customer-list:read": "customer-list:read",
  "customer-list:delete": "customer-list:delete",
  "me:read": "me:read",
  "me:update": "me:update",
  "me:delete": "me:delete",
  "message:read": "message:read",
  "message:list": "message:list",
  "message:info": "message:info",
  "message:test": "message:test",
  "message:resend": "message:resend",
  "message:delivery-task:list": "message:delivery-task:list",
  "message:transaction-log:read": "message:transaction-log:read",
  "message:transaction-log:list": "message:transaction-log:list",
  "pos:create": "pos:create",
  "pos:read": "pos:read",
  "pos:list": "pos:list",
  "pos:update": "pos:update",
  "pos:delete": "pos:delete",
  "settings:read": "settings:read",
  "settings:update": "settings:update",
  "statistics:read": "statistics:read",
  "supplier:audiologist:read": "supplier:audiologist:read",
  "supplier:audiologist:list": "supplier:audiologist:list",
  "supplier:audiologist:update": "supplier:audiologist:update",
  "supplier:audiologist:delete": "supplier:audiologist:delete",
  "supplier:audiologist:download": "supplier:audiologist:download",
  "user:create": "user:create",
  "user:read": "user:read",
  "user:list": "user:list",
  "user:update": "user:update",
  "user:set-type": "user:set-type",
  "user:set-org-code": "user:set-org-code",
  "user:delete": "user:delete",
  "user:download": "user:download",
  "verification-code:batch:create": "verification-code:batch:create",
  "verification-code:batch:read": "verification-code:batch:read",
  "verification-code:batch:list": "verification-code:batch:list",
  "verification-code:batch:download": "verification-code:batch:download",
  "verification-code:batch:delete": "verification-code:batch:delete",
  "verification-code:invite": "verification-code:invite",
  "verification-code:apply": "verification-code:apply",
} as const;
